module.exports = __webpack_public_path__ + "img/Fx.f2c4e079.png";